import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Layout from "../../components/Layout.js";

const WarrantyMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (v) => v.replace(/[^0-9]/g, "");
  const [Description, setDescription] = useState("");
  const [Year, setYear] = useState("");
  const [Kilometer, setKilometer] = useState("");
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [gridRows, setGridRows] = useState([]);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [unqid, setUnqid] = useState("");
  const { state } = useLocation();

  const inputStyle = (error) => ({
    padding: "12px 15px",
    height: "45px",
    marginTop: "5px",
    borderRadius: "6px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    fontSize: "15px",
    boxSizing: "border-box",
    backgroundColor: "#fff",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });

  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);
  //--------Exit Working
  const handleExit = () => {
    navigate("/WarrantyMasterGrid");
  };

  useEffect(() => {
    loadGrid();
  }, []);

  const loadGrid = async () => {
    try {
      const response = await apiFetch(
        "/api/warranty-master/grid",
        { method: "POST", body: JSON.stringify({ what: "grid_details" }) },
      );
      const data = await response.json();
      if (data.err === "0") {
        const rows = data.data.map((row) => ({
          modelId: row.sp_78_3,
          variantId: row.sp_78_4,
          Model: row.model,
          Variant: row.variant,
          Fuel: row.sp_78_9,
          slab1Warranty: row.sp_78_5 ?? "",
          slab1Dealer: row.sp_78_6 ?? "",
          slab2Warranty: row.sp_78_7 ?? "",
          slab2Dealer: row.sp_78_8 ?? "",
        }));
        setGridRows(rows);
      }
    } catch (err) {
      console.error("Grid load error", err);
    }
  };
  const handleGridChange = (rowIndex, field, value) => {
    const updatedRows = [...gridRows];
    updatedRows[rowIndex] = {
      ...updatedRows[rowIndex],
      [field]: value.replace(/[^0-9]/g, ""),
    };
    setGridRows(updatedRows);
  };

  const handleSave = async () => {
    try {
      // ---------- PARENT SAVE ----------
      const parentResponse = await apiFetch(
        "/api/warranty-master/save",
        {
          method: "POST",
          body: JSON.stringify({
            what: "insert",
            description: Description,
            year: Year,
            kilometer: Kilometer,
            fromDate: FromDate.split("-").reverse().join("-"),
            toDate: ToDate.split("-").reverse().join("-"),
            userId: userId,
            ipAddress: ipAddress,
            serverIp: serverIp,
          }),
        },
      );
      const parentRes = await parentResponse.json();
      if (parentRes.err !== "0") {
        alert(parentRes.msg);
        return;
      }
      const parentId = parentRes.unqid;
      setUnqid(parentId);

      for (const row of gridRows) {
        await apiFetch("/api/warranty-master/save", {
          method: "POST",
          body: JSON.stringify({
            what: "ins",
            parentId: parentId,
            model: row.modelId,
            variant: row.variantId,
            fuel: row.Fuel,
            slab1Warranty: row.slab1Warranty || "0",
            slab1Dealer: row.slab1Dealer || "0",
            slab2Warranty: row.slab2Warranty || "0",
            slab2Dealer: row.slab2Dealer || "0",
          }),
        });
      }
      navigate("/WarrantyMasterGrid");
      alert("Saved successfully ✅");
    } catch (err) {
      console.error("Save error", err);
      alert("Error while saving");
    }
  };
  useEffect(() => {
    if (state?.unqid) {
      setIsEditMode(true);
      loadEditData(state.unqid);
    }
  }, [state]);

  const loadEditData = async (unqid) => {
    try {
      const parentResponse = await apiFetch(
        "/api/warranty-master/edit",
        { method: "POST", body: JSON.stringify({ unqid }) },
      );
      const parentRes = await parentResponse.json();
      if (parentRes.err === "0") {
        const d = parentRes.data;
        setUnqid(d.unq);
        setDescription(d.descp);
        setYear(d.year);
        setKilometer(d.kilometer);
        setFromDate(d.fdate.split("/").reverse().join("-"));
        setToDate(d.tdate.split("/").reverse().join("-"));
      }

      const gridResponse = await apiFetch(
        "/api/warranty-master/edit-grid",
        { method: "POST", body: JSON.stringify({ unqid }) },
      );
      const gridRes = await gridResponse.json();
      if (gridRes.err === "0") {
        const rows = gridRes.data.map((r) => ({
          childId: r.sp_78_2,
          modelId: r.sp_78_3,
          variantId: r.sp_78_4,
          Model: r.model,
          Variant: r.variant,
          Fuel: r.sp_78_9,
          slab1Warranty: r.sp_78_5,
          slab1Dealer: r.sp_78_6,
          slab2Warranty: r.sp_78_7,
          slab2Dealer: r.sp_78_8,
        }));
        setGridRows(rows);
      }
    } catch (err) {
      console.error("Edit load error", err);
    }
  };
  const handleUpdate = async () => {
    try {
      // ---------- UPDATE PARENT ----------
      const parentResponse = await apiFetch(
        "/api/warranty-master/update",
        {
          method: "POST",
          body: JSON.stringify({
            unqid,
            description: Description,
            year: Year,
            kilometer: Kilometer,
            fromDate: FromDate.split("-").reverse().join("-"),
            toDate: ToDate.split("-").reverse().join("-"),
          }),
        },
      );
      const parentRes = await parentResponse.json();
      if (parentRes.err !== "0") {
        alert(parentRes.msg);
        return;
      }

      for (const row of gridRows) {
        await apiFetch(
          "/api/warranty-master/update-grid",
          {
            method: "POST",
            body: JSON.stringify({
              childId: row.childId,
              slab1Warranty: row.slab1Warranty || "0",
              slab1Dealer: row.slab1Dealer || "0",
              slab2Warranty: row.slab2Warranty || "0",
              slab2Dealer: row.slab2Dealer || "0",
            }),
          },
        );
      }

      alert("Updated successfully ✅");
      navigate("/WarrantyMasterGrid");
    } catch (err) {
      console.error("Update error", err);
      alert("Error while updating");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Other Master</div>

          {/* Form Section */}
          <div className="form-row">
            <div className="form-column">
              <label>Description</label>
              <input
                type="text"
                value={Description}
                onChange={(e) => setDescription(allowAlphabets(e.target.value))}
                style={inputStyle(errors.Description)}
              />
            </div>
            <div className="form-column">
              <label>Year</label>
              <input
                type="text"
                value={Year}
                onChange={(e) => setYear(allowNumbers(e.target.value))}
                style={inputStyle(errors.Year)}
              />
            </div>
            <div className="form-column">
              <label>Kilometer</label>
              <input
                type="text"
                value={Kilometer}
                onChange={(e) => setKilometer(e.target.value)}
                style={inputStyle(errors.Year)}
              />
            </div>
            <div className="form-column">
              <label>From Date</label>

              <div className="date-wrapper">
                <input
                  type="date"
                  value={FromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="custom-date-input"
                />
              </div>
            </div>

            <div className="form-column">
              <label>To Date</label>

              <div className="date-wrapper">
                <input
                  type="date"
                  value={ToDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="custom-date-input"
                />
              </div>
            </div>
          </div>
          {/* Grid Section */}
          {/* ================= GRID SECTION ================= */}
          <div className="grid-outer-container">
            <div className="grid-scroll-container">
              <table className="warranty-table">
                <colgroup>
                  <col className="col-sn" />
                  <col className="col-model" />
                  <col className="col-variant" />
                  <col className="col-fuel" />
                  <col className="col-slab" />
                  <col className="col-slab" />
                  <col className="col-slab" />
                  <col className="col-slab" />
                </colgroup>

                <thead>
                  <tr>
                    <th rowSpan="2">S.N.</th>
                    <th rowSpan="2">Model</th>
                    <th rowSpan="2">Variant</th>
                    <th rowSpan="2">Fuel</th>
                    <th colSpan="2">Slab 1</th>
                    <th colSpan="2">Slab 2</th>
                  </tr>
                  <tr>
                    <th>Warranty Amount</th>
                    <th>Dealer Commission</th>
                    <th>Warranty Amount</th>
                    <th>Dealer Commission</th>
                  </tr>
                </thead>

                <tbody>
                  {gridRows.map((r, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{r.Model}</td>
                      <td className="left">{r.Variant}</td>
                      <td>{r.Fuel}</td>

                      <td>
                        <input
                          className="grid-input"
                          value={r.slab1Warranty}
                          onChange={(e) =>
                            handleGridChange(i, "slab1Warranty", e.target.value)
                          }
                        />
                      </td>

                      <td>
                        <input
                          className="grid-input"
                          value={r.slab1Dealer}
                          onChange={(e) =>
                            handleGridChange(i, "slab1Dealer", e.target.value)
                          }
                        />
                      </td>

                      <td>
                        <input
                          className="grid-input"
                          value={r.slab2Warranty}
                          onChange={(e) =>
                            handleGridChange(i, "slab2Warranty", e.target.value)
                          }
                        />
                      </td>

                      <td>
                        <input
                          className="grid-input"
                          value={r.slab2Dealer}
                          onChange={(e) =>
                            handleGridChange(i, "slab2Dealer", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Buttons */}
          <div style={buttonContainerStyle}>
            {!isEditMode && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      <style>
        {`
/* ================= PAGE ================= */

/* ================= PAGE ================= */

.page-container{
  width:100%;
  min-height:100vh;
  background:#f4f6f8;
  display:flex;
  justify-content:center;
  padding:10px;
}

.container{
  width:100%;
  max-width:1600px;
  background:#fff;
  border-radius:10px;
  padding:16px;
  box-shadow:0 4px 10px rgba(0,0,0,.08);
}

/* ================= HEADER ================= */

.header{
  background:#8B1E3F;
  color:#fff;
  text-align:center;
  padding:14px;
  font-size:1.6rem;
  font-weight:700;
  border-radius:8px;
  margin-bottom:16px;
}

/* ================= FORM ================= */

.form-row{
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(240px,1fr));
  gap:14px;
  margin-bottom:14px;
}

.form-column{
  display:flex;
  flex-direction:column;
}

label{
  font-weight:600;
  margin-bottom:4px;
  font-size:14px;
}

input{
  height:42px;
  padding:8px 12px;
  border-radius:6px;
  border:1px solid #ccc;
  font-size:14px;
}

/* ================= GRID CONTAINER ================= */

.grid-outer-container{
  height:65vh;                 /* main scroll height */
  border:1px solid #ccc;
  border-radius:8px;
  overflow:hidden;
  background:#fff;
}

.grid-scroll-container{
  height:100%;
  overflow-y:auto;
  overflow-x:auto;
  -webkit-overflow-scrolling:touch;
}

/* ================= TABLE ================= */

.warranty-table{
  width:100%;
  min-width:1200px;            /* force horizontal scroll on mobile */
  border-collapse:collapse;
  table-layout:fixed;
}

.warranty-table th,
.warranty-table td{
  border:1px solid #ddd;
  padding:6px;
  text-align:center;
  background:#fff;
  font-size:13px;
}

/* ================= STICKY HEADER ================= */

.warranty-table thead tr:first-child th{
  position:sticky;
  top:0;
  z-index:10;
  background:#f8bcbc;
  height:40px;
}

.warranty-table thead tr:nth-child(2) th{
  position:sticky;
  top:40px;
  z-index:9;
  background:#f8bcbc;
}

/* ================= INPUTS IN GRID ================= */

.grid-input{
  width:100%;
  height:32px;
  border:1px solid #ccc;
  border-radius:4px;
  text-align:center;
  font-size:13px;
}

.grid-input:focus{
  outline:none;
  background:#fff3f3;
  border-color:#8B1E3F;
}

/* ================= BUTTONS ================= */

.button-container{
  display:flex;
  justify-content:center;
  gap:14px;
  margin-top:18px;
}

.button-container button{
  min-width:120px;
  padding:12px 0;
  border-radius:6px;
  border:none;
  font-weight:700;
  color:#fff;
  cursor:pointer;
}

.btn-save{background:#4caf50;}
.btn-exit{background:#ab2025;}

/* ================= RESPONSIVE ================= */

/* Tablet */
@media(max-width:992px){
  .grid-outer-container{
    height:55vh;
  }
}

/* Mobile */
@media(max-width:768px){

  .form-row{
    grid-template-columns:1fr;
  }

  .grid-outer-container{
    height:50vh;
  }

  .warranty-table{
    min-width:1000px;   /* horizontal scroll always */
  }

  .button-container{
    flex-direction:row;
  }

  .button-container button{
    flex:1;
  }
}

/* Very small phones */
@media(max-width:420px){

  .header{
    font-size:1.3rem;
  }

  input{
    height:38px;
  }

  .grid-outer-container{
    height:45vh;
  }
}
/* Make date input look exactly like normal text input */

input[type="date"]{
  height:42px;
  width:100%;
  padding:8px 12px;
  border-radius:6px;
  border:1px solid #ccc;
  font-size:14px;
  background:#fff;
  box-sizing:border-box;
  appearance:none;
  -webkit-appearance:none;
  -moz-appearance:none;
}

/* Fix calendar icon position */

input[type="date"]::-webkit-calendar-picker-indicator{
  cursor:pointer;
  opacity:.7;
  padding-right:4px;
}

/* Focus effect same as others */

input[type="date"]:focus{
  outline:none;
  border-color:#8B1E3F;
  background:#fff3f3;
}

      
        `}
      </style>
    </Layout>
  );
};

export default WarrantyMasterDetailsDesign;
